import { VueModule } from '@Foundation/utilities';
import articleTagging from './code/Scripts/components/article-tagging.vue';

export default VueModule({
    components: {
        articleTagging
    }
});